import { render, staticRenderFns } from "./InventaireRapp.vue?vue&type=template&id=5983bc8a&scoped=true&"
import script from "./InventaireRapp.vue?vue&type=script&lang=js&"
export * from "./InventaireRapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983bc8a",
  null
  
)

export default component.exports